import { useShowMessage } from "../../functions/Common/showMessage";
import useFetch from "../../hooks/useFetch";
import { useState } from "react";

export default function useGetConversationList() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  const [conversationList, setConversationList] = useState([]);
  const [conversationLoading, setConversationLoading] = useState(false);

  function getConversationList() {
    fetchWrapper({
      endpoint_url: "conversation/getConversationList",
      setLoading: setConversationLoading,
      method: "GET",
      set_content_type_header: false,
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          setConversationList(fetch_output.data);
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        showMessage({ apiType: "fetch", message: "get conversation list" });
      },
      onResponseError: () => {
        showMessage({ apiType: "response", message: "get conversation list" });
      },
    });
  }

  return { getConversationList, conversationList, conversationLoading };
}
